module.exports = __webpack_public_path__ + "static/media/ruzhishengming1.31f087a6.png";